import { Option } from '../../classes';

export type ToggleEvent = ToggleStarted | ToggleSucceeded | ToggleFailed;

export interface ToggleEventBase {
  option: Option;
  type: ToggleEventTypes;
  checking: boolean;
}

export interface ToggleStarted extends ToggleEventBase {
  type: ToggleEventTypes.ToggleStarted;
}
export interface ToggleSucceeded extends ToggleEventBase {
  type: ToggleEventTypes.ToggleSucceeded;
}
export interface ToggleFailed extends ToggleEventBase {
  type: ToggleEventTypes.ToggleFailed;
}

export enum ToggleEventTypes {
  ToggleStarted = 'ToggleStarted',
  ToggleSucceeded = 'ToggleSucceeded',
  ToggleFailed = 'ToggleFailed'
}
